"use strict";
const useFocus = require("./useFocus-CMnc2E66.js");
const useFocusVisible = require("./useFocusVisible-DI97tCCV.js");
const useFocusWithin = require("./useFocusWithin-DJC0ie9P.js");
const React = require("react");
function $f7dceffc5ad7768b$export$4e328f61c538687f(props = {}) {
  let { autoFocus = false, isTextInput, within } = props;
  let state = React.useRef({
    isFocused: false,
    isFocusVisible: autoFocus || useFocusVisible.$507fabe10e71c6fb$export$b9b3dfddab17db27()
  });
  let [isFocused, setFocused] = React.useState(false);
  let [isFocusVisibleState, setFocusVisible] = React.useState(() => state.current.isFocused && state.current.isFocusVisible);
  let updateState = React.useCallback(() => setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
  let onFocusChange = React.useCallback((isFocused2) => {
    state.current.isFocused = isFocused2;
    setFocused(isFocused2);
    updateState();
  }, [
    updateState
  ]);
  useFocusVisible.$507fabe10e71c6fb$export$ec71b4b83ac08ec3((isFocusVisible) => {
    state.current.isFocusVisible = isFocusVisible;
    updateState();
  }, [], {
    isTextInput
  });
  let { focusProps } = useFocus.$a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    isDisabled: within,
    onFocusChange
  });
  let { focusWithinProps } = useFocusWithin.$9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !within,
    onFocusWithinChange: onFocusChange
  });
  return {
    isFocused,
    isFocusVisible: isFocusVisibleState,
    focusProps: within ? focusWithinProps : focusProps
  };
}
exports.$f7dceffc5ad7768b$export$4e328f61c538687f = $f7dceffc5ad7768b$export$4e328f61c538687f;
